import { makeStyles } from '@material-ui/styles';

export const lightStyles = makeStyles(() => ({
  root: {
    borderRadius: '8px 8px 4px 4px',
    width: '100%',
  },
  input: {
    backgroundColor: '#e2e1eb',
    color: `#24206b !important`,
    borderRadius: '8px 8px 4px 4px',
    fontWeight: 700,
    fontFamily: ['Open Sans', 'ui-sans-serif', 'sans-serif'],
    height: '3.5rem !important',
    // focus line
    '&:after': {
      borderBottom: 'none',
    },
    // unfocus line
    '&:before': {
      borderBottomColor: '#24206b',
      borderBottomWidth: '2px',
      borderBottomStyle: 'solid !important',
      borderBottomLeftRadius: '4px',
      borderBottomRightRadius: '4px',
    },
    '&:hover': {
      backgroundColor: `#aeabc4 !important`,
      '&:before': {
        borderBottomColor: '#24206b',
        borderBottomWidth: '2px !important',
      },
    },
  },
  inputBase: {
    padding: '0rem 1rem 0rem 1rem !important',
  },
  inputWithLabel: {
    padding: '1rem 1rem 0rem 1rem !important',
  },
  inputFocus: {
    backgroundColor: `#aeabc4 !important`,
  },
  label: {
    color: `#24206b !important`,
    fontFamily: ['Open Sans', 'ui-sans-serif', 'sans-serif'],
  },
  helperText: {
    color: `#24206b !important`,
    fontFamily: ['Open Sans', 'ui-sans-serif', 'sans-serif'],
    background: '#FFE5E0',
    margin: '5px 0 0 0',
    borderRadius: '4px',
    width: '95%',
    padding: '8px 16px',
    fontWeight: 400,
  },
  disabled: {
    backgroundColor: `#aeabc4 !important`,
    borderRadius: '8px 8px 4px 4px',
    '-webkit-text-fill-color': `#585380 !important`,
    fontWeight: 700,
    fontFamily: ['Open Sans', 'ui-sans-serif', 'sans-serif'],
    '&:before': {
      borderBottomColor: '#24206b',
      borderBottomWidth: '2px',
      borderBottomStyle: 'solid !important',
    },
  },
  error: {
    '&:before': {
      borderBottomColor: `#f55d45 !important`,
    },
    '&:after': {
      borderBottomColor: `#f55d45 !important`,
    },
  },
}));
